import { Box } from '@mui/material';
import { Filters } from './components/Filters'
import { MainData } from './components/MainData';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReportsTables } from './components/ReportsTables';
import useGlobalContext from '../../Hooks/useGlobalContext';
import 'leaflet/dist/leaflet.css';
import { ApiFetch } from '../../Utils/ApiFetch';
import Loading from '../../Components/Generic/Loading';
import { useHistory } from 'react-router-dom';
import { HOME } from '../../constants/paths';
  
export const ControlPanel = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const globalContext = useGlobalContext();
    const { selectedAsset, selectedBox } = globalContext;
    const [appliedFilters, setAppliedFilters] = useState(null)
    const [loadingPanel, setLoadingPanel] = useState(false)
    const [errorLoadPanel, setErrorLoadPanel] = useState(null)
    const [panelData, setPanelData] = useState({resumes: [],tables: []})
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        const authorized = globalContext.getSessionDataByKey('models')?.
            [selectedAsset.id]?.menu?.some(item => item.path === '/controlPanel');
    
        if (!authorized) {
            history.push(HOME);
        } else {
            setIsAuthorized(true);
        }
    }, [ history, selectedAsset.id ]);
    
    useEffect(() => {
        if (!isAuthorized) return;

        setLoadingPanel(true);
        ApiFetch(
            `controlPanel/panelData/${selectedAsset.id}/${selectedBox.id}`,
            globalContext,
            true,
            async (result) => {
                if (result.status === 200) {
                    const res = await result.json();
                    setPanelData(res);
                    setErrorLoadPanel(null)
                }
                setLoadingPanel(false);
            },
            (error) => {
                error.json().then(err => {
                    setErrorLoadPanel(err);
                });
                setPanelData({ resumes: [], tables: [] });
                setLoadingPanel(false);
            },
            {
                method: 'POST',
                body: JSON.stringify({ filters: appliedFilters })
            }
        );
    }, [isAuthorized, appliedFilters, selectedAsset.id, selectedBox.id]);
    
    return (
        <Box>
            <Filters 
                t={t} 
                isAuthorized={isAuthorized} 
                appliedFilters={appliedFilters} 
                setAppliedFilters={setAppliedFilters} 
                globalContext={globalContext} 
                selectedAsset={selectedAsset} 
                selectedBox={selectedBox}
            />
            
            {loadingPanel ? (
                <Box 
                    sx={{ 
                        width: '100%',
                        justifyContent: 'center',
                        my: 4
                    }}
                >
                    <Loading height={50} size={50}/>
                </Box>
            ) : (
                <>
                    <MainData t={t} error={errorLoadPanel}  selectedAsset={selectedAsset} data={panelData?.resumes}/>
                    <ReportsTables t={t} data={panelData?.tables} globalContext={globalContext} selectedAsset={selectedAsset}/>
                </>
            )}

        </Box>
    );
}
  